module.exports = __FOREMAN_VENDOR__PROP_TYPES__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__PROP_TYPES__"
// module id = prop-types
// module chunks = 1